<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link
                class="btn btn-sm"
                :to="{ name: 'OPENVPNHistoryList' }"
              >
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Connection History
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Connection History</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="OPENVPNHistory">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div class="row">
                    <div class="col-md-6 form-group">
                      <label class="control-label">Audra</label>
                      <input
                        type="text"
                        id="ap_wi_mac"
                        name="ap_wi_mac"
                        v-model="value.ap_wi_mac"
                        class="form-control ap_wi_mac"
                        placeholder="Audra"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Name</label>
                      <input
                        type="text"
                        id="user_name"
                        name="user_name"
                        v-model="value.user_name"
                        class="form-control user_name"
                        placeholder="Name"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Source IP</label>
                      <input
                        type="text"
                        id="source_ip"
                        name="source_ip"
                        v-model="value.source_ip"
                        class="form-control source_ip"
                        placeholder="Source IP"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">VPN IP</label>
                      <input
                        type="text"
                        id="vpn_ip"
                        name="vpn_ip"
                        v-model="value.vpn_ip"
                        class="form-control vpn_ip"
                        placeholder="VPN IP"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Download</label>
                      <input
                        type="text"
                        id="download"
                        name="download"
                        v-model="value.download"
                        class="form-control download"
                        placeholder="Download"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Upload</label>
                      <input
                        type="text"
                        id="upload"
                        name="upload"
                        v-model="value.upload"
                        class="form-control upload"
                        placeholder="Upload"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Start Time</label>
                      <input
                        type="text"
                        id="start_time"
                        name="start_time"
                        v-model="value.start_time"
                        class="form-control start_time"
                        placeholder="Start Time"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">End Time</label>
                      <input
                        type="text"
                        id="end_time"
                        name="end_time"
                        v-model="value.end_time"
                        class="form-control end_time"
                        placeholder="End Time"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'OPENVPNHistoryForm',
  metaInfo: {
    title: 'OPEN VPN History | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {}
  }),
  methods: {
    handleSubmission () {
      const _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.is_loading = true
          let api_url = '/open_vpn_histories'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/open_vpn_histories/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message)
              _this.$router.push({ name: 'OPENVPNHistoryList' })
            })
            .catch(errors => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message)
              }
              _this.$setErrorsFromResponse(errors.response.data)
            })
            .finally(() => {
              _this.is_loading = false
            })
        }
      })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = '/open_vpn_histories/' + id
        axios
          .get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // console.log("error " + error);
            reject(error)
          })
      })
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then(response => {
            this.value = response.data
          })
          .catch(error => {
            console.log(error.response)
          })
      }

      this.is_loading = false
    }
  },
  mounted () {
    this.initialize()
  }
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>
